export function validarCpfCnpj(valor) {
  const documento = String(valor || "").replace(/\D/g, "");

  if (documento.length !== 11 && documento.length !== 14) {
    return false;
  }

  const isCPF = (cpf) => {
    if (/^(\d)\1{10}$/.test(cpf)) return false;

    let soma = 0;
    let peso = 10;
    for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf.charAt(i), 10) * peso;
      peso--;
    }
    let resto = 11 - (soma % 11);
    const dig1 = resto >= 10 ? "0" : String(resto);

    soma = 0;
    peso = 11;
    for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf.charAt(i), 10) * peso;
      peso--;
    }
    resto = 11 - (soma % 11);
    const dig2 = resto >= 10 ? "0" : String(resto);

    return dig1 === cpf.charAt(9) && dig2 === cpf.charAt(10);
  };

  const isCNPJ = (cnpj) => {
    if (/^(\d)\1{13}$/.test(cnpj)) return false;

    const calcularDigito = (base) => {
      let soma = 0;
      let peso = base.length - 7;
      for (let i = 0; i < base.length; i++) {
        soma += parseInt(base.charAt(i), 10) * peso;
        peso = peso === 2 ? 9 : peso - 1;
      }
      const resto = soma % 11;
      return resto < 2 ? 0 : 11 - resto;
    };

    const dig1 = calcularDigito(cnpj.substring(0, 12));
    const dig2 = calcularDigito(cnpj.substring(0, 12) + dig1);

    return (
      dig1 === parseInt(cnpj.charAt(12), 10) &&
      dig2 === parseInt(cnpj.charAt(13), 10)
    );
  };

  return documento.length === 11 ? isCPF(documento) : isCNPJ(documento);
}
